import { makeStyles } from '@mui/styles';

export const useDataGridStyles = makeStyles((theme) => ({
    root: {
        width: 1200,
        margin: 32,
        overflowX: 'auto',
    },
    dataGrid: {
        '&.MuiDataGrid-root .MuiDataGrid-cell:focus-within': {
            outline: 'none !important',
        },
    },
    dataGridAutoHeight: {
        '&.MuiDataGrid-root .MuiDataGrid-cell:focus-within': {
            outline: 'none !important',
        },
        '&.MuiDataGrid-root .MuiDataGrid-row:hover': {
            backgroundColor: 'inherit',
        },
    },
}));

export const formatTime = (params) => {
    if (!params.value) return 'N/A';

    const d = new Date(params.value.replace(' ', 'T'));
    return d.toLocaleDateString();
};

export const formatCurrency = (params) => {
    if (!params.value) return undefined;

    return params.value / 100;
};

export const dateComparator = (v1, v2) => {
    if (v1 === 'N/A' && v2 === 'N/A') {
        return 0;
    } else if (v1 === 'N/A') {
        return -1;
    } else if (v2 === 'N/A') {
        return 1;
    }

    return new Date(v1) - new Date(v2);
};

export const MAX_ROWS = 10;
